module.exports = __webpack_public_path__ + "static/img/buddy_pictgrid34_920x851.efb8e11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/buddy_pictgrid34_920x851.jpg
// module id = SSeX
// module chunks = 0